export const dateFieldI18n = [
  {
    key: 'date-format',
    de: 'Format TT.MM.JJJJ',
    en: 'format YYYY.MM.DD',
  },
  {
    // Not used for mode=2021
    key: 'date-previous',
    de: 'Vorheriger Tag',
    en: 'Previous day',
  },
  {
    // Not used for mode=2021
    key: 'date-next',
    de: 'Nächster Tag',
    en: 'Next day',
  },
  {
    key: 'open-calendar',
    de: 'Kalender öffnen',
    en: 'Open calendar',
    it: 'Calendario aperto',
    fr: 'Ouvrir le calendrier',
    nl: 'Open kalender',
  },
  {
    key: 'date-missing',
    de: 'Wählen Sie bitte ein Datum aus.',
    en: 'Please select a date.',
    it: 'Selezionare una data.',
    fr: 'Veuillez sélectionner une date.',
    nl: 'Kies een datum.',
  },
  {
    key: 'date-invalid',
    de: 'Das Datum ist ungültig.',
    en: 'The date is invalid.',
    it: 'Selezionare una data.',
    fr: 'Veuillez sélectionner une date.',
    nl: 'Kies een datum.',
  },
];
//# sourceMappingURL=date-field-i18n.js.map
